/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AbortAssessmentRequest} from "../model/abort-assessment-request";
import {AddAssessableGroupRequest} from "../model/add-assessable-group-request";
import {AddAssessableItemRequest} from "../model/add-assessable-item-request";
import {AssessableItemGroup} from "../model/assessable-item-group";
import {Assessment} from "../model/assessment";
import {AssessmentItem} from "../model/assessment-item";
import {CompetenceCategoryEntry} from "../model/competence-category-entry";
import {ConvertAssessmentToCatalogueRequest} from "../model/convert-assessment-to-catalogue-request";
import {CreateAssessmentRequest} from "../model/create-assessment-request";
import {CreateUserRecordingAssessmentForPeerPracticeRequest} from "../model/create-user-recording-assessment-for-peer-practice-request";
import {CreateUserRecordingAssessmentRequest} from "../model/create-user-recording-assessment-request";
import {DeleteAssessmentRequest} from "../model/delete-assessment-request";
import {DeleteUserRecordingAssessmentRequest} from "../model/delete-user-recording-assessment-request";
import {DuplicateAssessmentRequest} from "../model/duplicate-assessment-request";
import {FinishAssessmentRequest} from "../model/finish-assessment-request";
import {ImportItemsFromAssessmentCatalogue} from "../model/import-items-from-assessment-catalogue";
import {ListData} from "../model/list-data";
import {SearchForUserParamRequest} from "../model/search-for-user-param-request";
import {SearchParamRequest} from "../model/search-param-request";
import {SuccessCreateResponse} from "../model/success-create-response";
import {SuccessResponse} from "../model/success-response";
import {UpdateAssessmentAnswerRequest} from "../model/update-assessment-answer-request";
import {UpdateAssessmentGroupActivationConditionRequest} from "../model/update-assessment-group-activation-condition-request";
import {UpdateAssessmentMetadataRequest} from "../model/update-assessment-metadata-request";
import {UpdateAssessmentNoteRequest} from "../model/update-assessment-note-request";
import {UpdateAssessmentRequest} from "../model/update-assessment-request";
import {UserRecordingAssessment} from "../model/user-recording-assessment";

@Injectable({
    providedIn: "root",
})
export class SimAssessmentService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public abortAssessment(request: AbortAssessmentRequest) {
        return super.post<SuccessResponse>(`/api/Assessment/AbortAssessment`, request);
    }

    public addAssessableGroup(request: AddAssessableGroupRequest) {
        return super.post<AssessableItemGroup<AssessmentItem>>(`/api/Assessment/AddAssessableGroup`, request);
    }

    public addAssessableItem(request: AddAssessableItemRequest) {
        return super.post<AssessmentItem>(`/api/Assessment/AddAssessableItem`, request);
    }

    public convertAssessmentToCatalogue(request: ConvertAssessmentToCatalogueRequest) {
        return super.post<Assessment>(`/api/Assessment/ConvertAssessmentToCatalogue`, request);
    }

    public createAssessment(request: CreateAssessmentRequest) {
        return super.post<SuccessCreateResponse>(`/api/Assessment/CreateAssessment`, request);
    }

    public createUserRecordingAssessment(request: CreateUserRecordingAssessmentRequest) {
        return super.post<UserRecordingAssessment>(`/api/Assessment/CreateUserRecordingAssessment`, request);
    }

    public createUserRecordingAssessmentForPeerPractice(request: CreateUserRecordingAssessmentForPeerPracticeRequest) {
        return super.post<UserRecordingAssessment>(`/api/Assessment/CreateUserRecordingAssessmentForPeerPractice`, request);
    }

    public deleteAssessment(request: DeleteAssessmentRequest) {
        return super.post<void>(`/api/Assessment/DeleteAssessment`, request);
    }

    public deleteUserRecordingAssessment(request: DeleteUserRecordingAssessmentRequest) {
        return super.post<SuccessResponse>(`/api/Assessment/DeleteUserRecordingAssessment`, request);
    }

    public downloadAssessment_Url(assessmentId: string) {
        return super.getUrl(`/api/Assessment/DownloadAssessment`, {assessmentId: assessmentId});
    }

    public downloadUserRecordingAssessment_Url(userRecordingAssessmentId: string) {
        return super.getUrl(`/api/Assessment/DownloadUserRecordingAssessment`, {userRecordingAssessmentId: userRecordingAssessmentId});
    }

    public downloadUserRecordingAssessmentsByFilter_Url(searchParameters: SearchParamRequest) {
        return super.getUrl(`/api/Assessment/DownloadUserRecordingAssessmentsByFilter`, {searchParameters: searchParameters}, ["searchParameters"]);
    }

    public downloadUserRecordingAssessmentsByFilterForUser_Url(searchParameters: SearchForUserParamRequest) {
        return super.getUrl(`/api/Assessment/DownloadUserRecordingAssessmentsByFilterForUser`, {searchParameters: searchParameters}, ["searchParameters"]);
    }

    public downloadUserRecordingAssessmentsById_Url(userRecordingAssessmentIds: string[]) {
        return super.getUrl(`/api/Assessment/DownloadUserRecordingAssessmentsById`, {userRecordingAssessmentIds: userRecordingAssessmentIds});
    }

    public downloadUserRecordingAssessmentsBySession_Url(examSessionId: string, studentId: string) {
        return super.getUrl(`/api/Assessment/DownloadUserRecordingAssessmentsBySession`, {examSessionId: examSessionId, studentId: studentId});
    }

    public downloadUserRecordingAssessmentsByStation_Url(examSessionId: string, stationId: string) {
        return super.getUrl(`/api/Assessment/DownloadUserRecordingAssessmentsByStation`, {examSessionId: examSessionId, stationId: stationId});
    }

    public duplicateAssessment(request: DuplicateAssessmentRequest) {
        return super.post<SuccessResponse>(`/api/Assessment/DuplicateAssessment`, request);
    }

    public finishAssessment(request: FinishAssessmentRequest) {
        return super.post<SuccessResponse>(`/api/Assessment/FinishAssessment`, request);
    }

    public finishAssessmentReview(request: FinishAssessmentRequest) {
        return super.post<SuccessResponse>(`/api/Assessment/FinishAssessmentReview`, request);
    }

    public finishAssessmentsForEvent(eventId: string, skipReview: boolean = false) {
        return super.get<void>(`/api/Assessment/FinishAssessmentsForEvent`, {eventId: eventId, skipReview: skipReview});
    }

    public finishAssessmentsForSession(sessionId: string, skipReview: boolean = false) {
        return super.get<void>(`/api/Assessment/FinishAssessmentsForSession`, {sessionId: sessionId, skipReview: skipReview});
    }

    public getAllUserRecordingAssessments(scenarioRecordingId: string) {
        return super.get<UserRecordingAssessment[]>(`/api/Assessment/GetAllUserRecordingAssessments`, {scenarioRecordingId: scenarioRecordingId});
    }

    public getAssessmentById(assessmentId: string) {
        return super.get<Assessment>(`/api/Assessment/GetAssessmentById`, {assessmentId: assessmentId});
    }

    public getCompetenceCategoryDistribution(userRecordingAssessmentId: string) {
        return super.get<{ [key: string]: CompetenceCategoryEntry; }>(`/api/Assessment/GetCompetenceCategoryDistribution`, {userRecordingAssessmentId: userRecordingAssessmentId});
    }

    public getCompetenceCategoryDistributionByIds(userRecordingAssessmentIds: string[]) {
        return super.post<{ [key: string]: { [key: string]: CompetenceCategoryEntry; }; }>(`/api/Assessment/GetCompetenceCategoryDistributionByIds`, userRecordingAssessmentIds);
    }

    public getFilteredAssessments(searchParameters: SearchParamRequest) {
        return super.get<ListData<Assessment>>(`/api/Assessment/GetFilteredAssessments`, {searchParameters: searchParameters}, ["searchParameters"]);
    }

    public getFilteredUserRecordingAssessments(searchParameters: SearchParamRequest) {
        return super.get<ListData<UserRecordingAssessment>>(`/api/Assessment/GetFilteredUserRecordingAssessments`, {searchParameters: searchParameters}, ["searchParameters"]);
    }

    public getFilteredUserRecordingAssessmentsForUser(searchParameters: SearchForUserParamRequest) {
        return super.get<ListData<UserRecordingAssessment>>(`/api/Assessment/GetFilteredUserRecordingAssessmentsForUser`, {searchParameters: searchParameters}, ["searchParameters"]);
    }

    public getUserRecordingAssessmentById(userRecordingAssessmentId: string) {
        return super.get<UserRecordingAssessment>(`/api/Assessment/GetUserRecordingAssessmentById`, {userRecordingAssessmentId: userRecordingAssessmentId});
    }

    public getUserRecordingAssessmentByIds(userRecordingAssessmentIds: string[]) {
        return super.post<UserRecordingAssessment[]>(`/api/Assessment/GetUserRecordingAssessmentByIds`, userRecordingAssessmentIds);
    }

    public getUserRecordingAssessments(scenarioRecordingId: string, userId: string = null) {
        return super.get<UserRecordingAssessment[]>(`/api/Assessment/GetUserRecordingAssessments`, {scenarioRecordingId: scenarioRecordingId, userId: userId});
    }

    public importItemsFromAssessmentCatalogue(request: ImportItemsFromAssessmentCatalogue) {
        return super.post<Assessment>(`/api/Assessment/ImportItemsFromAssessmentCatalogue`, request);
    }

    public loadAssessmentsByIds(assessmentIds: string[]) {
        return super.post<Assessment[]>(`/api/Assessment/LoadAssessmentsByIds`, assessmentIds);
    }

    public reopenAssessment(request: FinishAssessmentRequest) {
        return super.post<SuccessResponse>(`/api/Assessment/ReopenAssessment`, request);
    }

    public updateAnswer(request: UpdateAssessmentAnswerRequest) {
        return super.post<AssessmentItem>(`/api/Assessment/UpdateAnswer`, request);
    }

    public updateAssessment(request: UpdateAssessmentRequest) {
        return super.post<void>(`/api/Assessment/UpdateAssessment`, request);
    }

    public updateAssessmentGroupActivationCondition(request: UpdateAssessmentGroupActivationConditionRequest) {
        return super.post<Assessment>(`/api/Assessment/UpdateAssessmentGroupActivationCondition`, request);
    }

    public updateAssessmentMetadata(request: UpdateAssessmentMetadataRequest) {
        return super.post<Assessment>(`/api/Assessment/UpdateAssessmentMetadata`, request);
    }

    public updateAssessmentNote(request: UpdateAssessmentNoteRequest) {
        return super.post<SuccessResponse>(`/api/Assessment/UpdateAssessmentNote`, request);
    }
}